module.exports = __webpack_public_path__ + "img/07.66bbcfa5.png";